import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@repo/ui";
import { ArrowLeft, Plus } from "lucide-react";
import { ReportsTable } from "@/components/reports/reports-table";
import { ReportGenerator } from "@/components/reports/report-generator";

export const Route = createFileRoute("/_app/reports")({
  component: ReportsPage,
});

function ReportsPage() {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [showGenerator, setShowGenerator] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {showGenerator && (
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8"
              data-testid="reports-back-button"
              onClick={() => setShowGenerator(false)}
            >
              <ArrowLeft className="h-4 w-4" />
            </Button>
          )}
          <h1 className="text-2xl font-semibold text-foreground">
            {showGenerator ? "Generate Report" : "Reports"}
          </h1>
        </div>
        {!showGenerator && (
          <Button
            className="gap-2"
            data-testid="reports-generate-button"
            onClick={() => setShowGenerator(true)}
          >
            <Plus className="h-4 w-4" />
            Generate Report
          </Button>
        )}
      </div>

      {showGenerator ? (
        <ReportGenerator
          onGenerated={() => {
            setRefreshTrigger((prev) => prev + 1);
            setShowGenerator(false);
          }}
        />
      ) : (
        <ReportsTable sourceFilter="" refreshTrigger={refreshTrigger} />
      )}
    </div>
  );
}
